import $ from 'jquery'
import '../touch-punch'

export default function () {
    var rangeTimes = [];
    var range = $("#oc .range-slider");
    var range_min = range.data('min');
    var range_max = range.data('max');
    var range_step = range.data('step');

    range.slider({
        range: true,
        min: range_min,
        max: range_max,
        values: [0, 1440],
        step: range_step,
        slide: slideTime
    });

    function slideTime(event, ui){
        if (event && event.target) {
            var $rangeslider = $(event.target);
            var $rangen = $rangeslider.closest(".range");
            var rangen_n = parseInt($rangen.data('day'));
            var $rangetime = $rangeslider.next(".range-time");
        }

        $rangeslider.slider('enable');

        if (ui!==undefined) {
            var val0 = ui.values[0],
                val1 = ui.values[1];
        } else {
            var val0 = $rangeslider.slider('values', 0),
                val1 = $rangeslider.slider('values', 1);
        }

        var minutes0 = parseInt(val0 % 60, 10),
            hours0 = parseInt(val0 / 60 % 24, 10),
            minutes1 = parseInt(val1 % 60, 10),
            hours1 = parseInt(val1 / 60 % 24, 10);
        if (hours1==0) hours1=24;

        rangeTimes[rangen_n] = [getTime(hours0, minutes0),getTime(hours1, minutes1)];
        $rangetime.text(rangeTimes[rangen_n][0] + ' - ' + rangeTimes[rangen_n][1]);
        $('input[name="oc[time_before]"]').val(rangeTimes[rangen_n][0]);
        $('input[name="oc[time_after]"]').val(rangeTimes[rangen_n][1]);
    }

    function getTime(hours, minutes) {
        var time = null;
        minutes = minutes + "";
        if (minutes.length == 1) {
            minutes = "0" + minutes;
        }
        return hours + ":" + minutes;
    }

    /*slideTime({target:$('.range-slider')});*/
};



// WEBPACK FOOTER //
// ./src/webpack/frontend/ordercall/rangetime.js